import { defineStore } from "pinia";
import { reactive } from 'vue';
import { useAuthStore } from './authStore';
import { deviceRoot } from "../vue-client";
// Import slotStore to access measurementCorrections
import { useSlotStore } from './slotStore';

export const usePreferenceStore = defineStore('preference', () => {
  const preference = reactive({
    options: {
      waterTrend: false,
      unitF: false,
      turbidityTrend: true,
      showCustomChart: false,
      showPlaygroundChart: false,
      smoothPlot: false,
      fieldCalPlot: false,
      rawPlot: true,
      spikeRemovalFlag: false,
      showCA: true,
      showPC: true,

      // Custom chart options
      phycocyaninSelected: true,
      chlorASelected: false,
      waterTempSelected: false,
      phSelected: false,
      doSelected: false,
      psSelected: false,
      turbiditySelected: false,
      lightSelected: true,
      battSOCSelected: false,
      sigStrengthSelected: false,
      panelVoltsSelected: false,
      algaeRatioSelected: false,
      dayAvgPCSelected: false,
      dayAvgCASelected: false,
      dayAvgTUSelected: false,
      windSpeedSelected: false,
      precipitationIntensitySelected: false,

      phycocyaninAxis: 'left',
      chlorAAxis: 'left',
      waterTempAxis: 'left',
      phAxis: 'left',
      doAxis: 'left',
      psAxis: 'left',
      turbidityAxis: 'left',
      lightAxis: 'left',
      battSOCAxis: 'left',
      sigStrengthAxis: 'left',
      panelVoltsAxis: 'left',
      algaeRatioAxis: 'left',
      dayAvgPCAxis: 'left',
      dayAvgCAAxis: 'left',
      dayAvgTUAxis: 'left',
      windSpeedAxis: 'left',
      precipitationIntensityAxis: 'left',
      qualityControlOn:true, //exclusion switch (qualityControlOff has Deprecated)
      spikeRemovalThreshold:3,
      
      // Export options
      exportDetailDefault: true,
      exportTrendDefault: false,
      exportSpikeRemovalDefault: false,
      exportDataExclusionDefault: false
    }
  });

  const compPreference = reactive({
    options: {
    }
  });

  async function fetchPreference() {
    // Get user preferences
    const authStore = useAuthStore();
    const authString = "Bearer " + authStore.authUser.authToken;
    const fetchUrl = `${deviceRoot}/preferences/`;
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authString,
      },
    });

    const data = await response.json();
    Object.assign(preference.options, data);
  }

  async function fetchCompPreference() {
    const authStore = useAuthStore();
    const authString = "Bearer " + authStore.authUser.authToken;
    const fetchUrl = `${deviceRoot}/compSettings/`;
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authString,
      },
    });

    const data = await response.json();
    Object.assign(compPreference.options, data);
  }

  async function updatePreference(val) {
    const authStore = useAuthStore();
    const authString = "Bearer " + authStore.authUser.authToken;
    const fetchUrl = `${deviceRoot}/preferences/`;
    const response = await fetch(fetchUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: authString,
      },
      body: JSON.stringify(val),
    });

    const data = await response.json();
    Object.assign(preference.options, data);
  }

  async function updateCompPreference(val) {
    const authStore = useAuthStore();
    const authString = "Bearer " + authStore.authUser.authToken;
    const fetchUrl = `${deviceRoot}/compSettings/`;
    const response = await fetch(fetchUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: authString,
      },
      body: JSON.stringify(val),
    });

    const data = await response.json();
    Object.assign(compPreference.options, data);

    // Refresh measurement corrections after updating compPreference
    const slotStore = useSlotStore();
    if (slotStore.fetchMeasurementCorrections) {
      await slotStore.fetchMeasurementCorrections();
    }
  }



  function getSensorSelected() {
    const slotStore = useSlotStore();
    // Use measurementCorrections from slotStore
    const corrections = slotStore.measurementCorrections?.value || [];
    const sensorsSelected = corrections.map((correction) => {
      const sensor = correction.measurementName;
      // Use enabled flag from API response for selected state
      const selected = correction.enabled;
      // Use sensor name for text property
      const text = sensor;
      const { k1, k2, c1, c2, t1, compensationSensorName } = correction.parameters;
      // You may add minComp, maxComp, variance, etc. from compPreference if needed
      return {
        sensor,
        eventSource: correction.eventSource,
        selected,
        text,
        k1: parseFloat(k1),
        k2: parseFloat(k2),
        c1: parseFloat(c1),
        c2: parseFloat(c2),
        t1: parseFloat(t1),
        compensationSensorName,
        variance: 0 // or from compPreference if available
      };
    });
    return sensorsSelected;
  }

  return {
    preference,
    fetchPreference,
    updatePreference,
    getSensorSelected,
    fetchCompPreference,
    updateCompPreference
  }
});